import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../theme/color-palette';
import { BOGLE_REGULAR } from '../../constants/constant';

const { PURPLE, BOLD_WHITE, PURPLE_ACTIVE, TOGGLE_ACTIVE, LIGHT_GRAY_SHADE } =
	colors;

export const useStyles = makeStyles((isStoreDrilldown) => ({
	container: {
		boxSizing: 'border-box !important',
		display: 'flex',
		paddingLeft: isStoreDrilldown ? '8px' : '14px',
		paddingRight: '14px',
		paddingBottom: '10px',
		flexDirection: 'row',
		alignItems: 'center',
		width: '100%',
		'@media (max-width: 1300px)': {
			// margin: '10px 0',
			// padding: '5px',
			alignItems: 'flex-start',
			justifyContent: 'space-between',
		},
	},
	saveCategory: {
		'@media (max-width: 1300px)': {
			paddingTop: '0 !important',
			marginTop: '-5px !important',
		},
	},
	menuRow: {
		flex: 1,
		display: 'flex',
		justifyContent: 'space-between',
		'@media (max-width: 1300px)': {
			flexDirection: 'column-reverse',
			justifyContent: 'flex-start',
		},
	},
	menuFilters: {
		flex: 1,
		display: 'flex',
		justifyContent: 'flex-start',
		'@media (max-width: 1300px)': {
			flexDirection: 'column',
		},
	},

	menuFiltersRight: {
		// marginRight: '2%',
	},
	border: {
		position: 'relative',
		bottom: '-33px',
	},
	appFilter: {
		marginLeft: '8px',
		'@media (max-width: 1300px)': {
			marginLeft: '0px !important',
			marginTop: '10px !important',
		},
	},
	formControl: {
		'@media (max-width: 1300px)': {
			width: '100% !important',
		},
		'& label.Mui-focused': {
			color: PURPLE,
		},
		'& .MuiOutlinedInput-root': {
			'&.Mui-focused fieldset': {
				borderColor: PURPLE,
			},
		},
		'&:hover': {
			background: LIGHT_GRAY_SHADE,
		},
	},
	formControlCatman: {
		'@media (max-width: 1300px)': {
			width: '100% !important',
		},
		'& label.Mui-focused': {
			color: PURPLE,
		},
		'& .MuiOutlinedInput-root': {
			'&.Mui-focused fieldset': {
				borderColor: PURPLE,
			},
		},
		'&:hover': {
			background: LIGHT_GRAY_SHADE,
			borderRadius: '22px',
		},
	},
	categoryFormControl: {
		width: '100%',
		'& label.Mui-focused': {
			color: PURPLE,
		},
		'& .MuiOutlinedInput-root': {
			'&.Mui-focused fieldset': {
				borderColor: PURPLE,
			},
		},
	},
	defaultSaved: {
		padding: '12px 16px',
		position: 'absolute',
		left: '40%',
		top: '260px',
		background: ' #EAF3E6',
		boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)',
		borderRadius: '4px',
		zIndex: 1,
	},

	defaultNotSaved: {
		padding: '12px 16px',
		position: 'absolute',
		left: '36%',
		top: '265px',
		background: '#FCE8E9',
		boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)',
		borderRadius: '4px',
		zIndex: 1,
	},

	savedContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		height: '20px',
	},

	errorContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		height: '20px',
	},

	formatSavedText: {
		fontSize: '14px',
		letterSpacing: '0.25px',
		color: '#1D5F02',
	},
	formatErrorText: {
		fontSize: '14px',
		letterSpacing: '0.25px',
		color: '#9B1419',
	},
	modalBox: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		maxWidth: '980px',
		background: '#fff',
		boxShadow: '0px 5px 10px 3px rgba(0, 0, 0, 0.15)',
		padding: '15px',
		maxHeight: '840px',
		overflowY: 'auto',
	},
	backButtonParent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'left',
		columnGap: '10px',
		marginBottom: '15px',
	},
	cancelBtn: {
		border: '1px solid #d5d6d8',
		textTransform: 'none',
		padding: '3px 24px 0px',
	},
	applyBtn: {
		backgroundColor: '#3C228A',
		textTransform: 'none',
		color: '#fff',
		padding: '3px 24px 0px',
		'&:hover': {
			background: '#3C228A',
			cursor: 'pointer',
		},
	},
	modalHeaderTitle: {
		fontFamily: 'Bogle-Regular',
		fontSize: '18px',
		paddingTop: '4px',
	},
	businessHirerchyWrapper: {
		border: '1px solid #DADCE0',
		margin: '10px 0 20px 0',
		height: 'calc(100% - 110px)',
		overflow: 'auto',
	},
	hoverParent: {
		'&:hover': {
			background: '#f2f2f2',
			cursor: 'pointer',
		},
	},
	modalFooter: {
		display: 'flex',
		alignItems: 'right',
		justifyContent: 'right',
		columnGap: '10px',
	},
	snackbar: {
		margin: '0 auto',
		padding: '0 10px',
		width: '100% !important',
	},
	hierarchyFilter: {
		border: '1 solid black',
	},
	onFocus: {
		border: `${PURPLE_ACTIVE}`,
		backgroundColor: TOGGLE_ACTIVE,
		color: PURPLE_ACTIVE,
	},
}));

export const selectStyleMenu = {
	fontFamily: BOGLE_REGULAR,
	fontSize: '14px !important',
	'&& .Mui-selected': {
		backgroundColor: BOLD_WHITE,
	},
	'&& .Mui-checked': {
		color: PURPLE,
	},
};
